import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '../styles';
import { liveEventSections } from '../../domain';
import { InstagramIcon } from '../atoms/icons/instagram_icon';
export const LiveEventSchedules = ({ config }) => {
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.title) }, "Event Schedule"),
        liveEventSections(config).map((v, i) => {
            return (React.createElement("div", { className: css(styles.section), key: i },
                React.createElement("div", { className: css(styles.sectionTime) }, v.time),
                React.createElement("div", { className: css(styles.sectionCard) },
                    React.createElement("div", { className: css(styles.sectionCardLabel) }, v.label),
                    React.createElement("div", { className: css(styles.sectionCardTitle) }, v.title),
                    React.createElement("div", { className: css(styles.sectionCardDesc) }, v.desc),
                    React.createElement("div", { className: css(styles.instructor) },
                        React.createElement("img", { src: v.trainer.thumbnailURL, className: css(styles.instructorIcon) }),
                        React.createElement("div", { className: css(styles.instructorDetail) },
                            React.createElement("div", { className: css(styles.instructorLabel) }, v.trainerLabel),
                            React.createElement("div", { className: css(styles.instructorName) }, v.trainer.name),
                            React.createElement("div", { className: css(styles.instructorDesc) }, v.trainer.bio),
                            React.createElement("a", { href: v.trainer.instaUrl, className: css(styles.instagram), target: "_blank" },
                                React.createElement(InstagramIcon, null),
                                React.createElement("div", { className: css(styles.instructorInstagram) },
                                    v.trainer.name,
                                    "\u306EInstagram")))))));
        })));
};
const styles = StyleSheet.create({
    container: {
        borderTop: `1px solid ${Colors.Gray}`,
        padding: '28px 24px',
        [MediaBreakPointUp.XL]: {
            padding: '40px 0 170px',
        },
    },
    title: {
        fontSize: 22,
        fontWeight: 'bold',
        marginBottom: 4,
    },
    section: {
        marginTop: 24,
    },
    sectionTime: {
        fontWeight: 'bold',
        marginBottom: 12,
        [MediaBreakPointUp.XL]: {
            fontSize: 18,
        },
    },
    sectionCard: {
        backgroundColor: Colors.White,
        position: 'relative',
        padding: '68px 20px 24px',
        [MediaBreakPointUp.MD]: {
            padding: '68px 30px 24px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '34px 40px 34px 160px',
        },
    },
    sectionCardLabel: {
        fontSize: 14,
        fontWeight: 'bold',
        padding: '8px 11px',
        textAlign: 'center',
        backgroundColor: Colors.Orange,
        color: Colors.White,
        borderRadius: '0px 20px 20px 0px',
        position: 'absolute',
        left: 0,
        top: 16,
        width: 134,
        [MediaBreakPointUp.XL]: {
            top: 34,
        },
    },
    sectionCardTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 8,
        [MediaBreakPointUp.XL]: {
            fontSize: 18,
        },
    },
    sectionCardDesc: {
        fontSize: 13,
        lineHeight: '21px',
        whiteSpace: 'pre-wrap',
        [MediaBreakPointUp.XL]: {
            fontSize: 14,
        },
    },
    instructor: {
        marginTop: 20,
        display: 'flex',
    },
    instructorIcon: {
        borderRadius: '50%',
        border: `1px solid ${Colors.Gray}`,
        width: 44,
        height: 44,
        marginRight: 12,
        [MediaBreakPointUp.XL]: {
            width: 54,
            height: 54,
        },
    },
    instructorDetail: {
        marginTop: 4,
    },
    instructorLabel: {
        fontSize: 11,
        fontWeight: 'bold',
        color: Colors.GrayDarkest,
        whiteSpace: 'pre-wrap',
    },
    instructorName: {
        fontSize: 14,
        fontWeight: 'bold',
        margin: '2px 0 6px',
        [MediaBreakPointUp.XL]: {
            fontSize: 16,
        },
    },
    instructorDesc: {
        fontSize: 12,
        color: Colors.GrayDarkest,
        marginBottom: 6,
        lineHeight: '19px',
        whiteSpace: 'pre-wrap',
        [MediaBreakPointUp.XL]: {
            fontSize: 13,
            marginBottom: 8,
            lineHeight: '20px',
        },
    },
    instructorInstagramIcon: {
        height: 16,
        width: 16,
    },
    instagram: {
        display: 'flex',
        alignItems: 'center',
    },
    instructorInstagram: {
        fontSize: 12,
        color: Colors.Primary,
        marginLeft: 8,
        textDecoration: 'underline',
    },
});
